module.exports = __webpack_public_path__ + "assets/img/00113.fe4b339d.png";